import classes from "./EventBannerPage.module.css";
import BannerClasses from "../../components/EventBanners.module.css";
import {
    ALL_ROLES,
    CREATION_ROLES
} from "../../utils/constants";
import SettingsClasses from "../PlatformSetting/Settings.module.css";
import YuJaRadioGroup from "../../components/standardization/YuJaRadioGroup";
import YuJaButton from "../../components/standardization/YuJaButton";
import YuJaSelect from "../../components/standardization/YuJaSelect";
import YuJaTextArea from "../../components/standardization/YuJaTextArea";
import YuJaTextField from "../../components/standardization/YuJaTextField";
import React, {Fragment, useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {Button} from "@base-ui/react/button";
import {ReactComponent as BACK} from "../../images/arrow-left-purple.svg";
import {ReactComponent as ERROR} from "../../images/cross_cricle_red.svg"
import {ReactComponent as CHECK} from "../../images/check_marker_green.svg"
import { ReactComponent as ARROW_RIGHT } from "../../images/arrow_right_black.svg";
import {EVENT_BANNER_LOCATION_TYPES, EVENT_BANNER_PAGE_VIEW_TYPES} from "./EventBannerManagementPage";
import YuJaDatePicker from "../../components/YuJaDatePicker";
import YuJaDialog from "../../components/standardization/YuJaDialog";
import {Table} from "react-bootstrap";
import TableSortHeaderNew from "../../components/TableSortHeaderNew";
import {YuJaCheckbox} from "../../components/standardization/YuJaCheckbox";
import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";
import {Separator} from "@base-ui/react/separator";
import {BannerContent, Close} from "../../components/EventBanners";
import styles from "../../components/EventBanners.module.css";
import {InstitutionApiCalls} from "../../apis/InstitutionApiCalls";


export default function EventBannerDetail({view, setView, selectedBannerEvent, institutions, onBack}) {
    const {t} = useTranslation();
    const {saveEventBanner} = InstitutionApiCalls();

    const [tempBannerEvent, setTempBannerEvent] = useState({});
    const [roleValid, setRoleValid] = useState(true);
    const [roleErrorMsg, setRoleErrorMsg] = useState("");
    const [descriptionValid, setDescriptionValid] = useState(true);
    const [descriptionErrorMsg, setDescriptionErrorMsg] = useState("");
    const [domainValid, setDomainValid] = useState(true);
    const [domainErrorMsg, setDomainErrorMsg] = useState("");
    const [buttonValid, setButtonValid] = useState(true);
    const [buttonErrorMsg, setButtonErrorMsg] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [isInstitutionsDialogOpened, setIsInstitutionsDialogOpened] = useState(false);
    const [isSelectedInstDialogOpened, setIsSelectedInstDialogOpened] = useState(false);
    const [institutionData, setInstitutionData] = useState([]);
    const [sortedBy, setSortedBy] = useState("");
    const [selectedInstitutionSortedBy, setSelectedInstitutionSortedBy] = useState("");
    const [acknowledgeText, setAcknowledgeText] = useState("");
    const [savingInProgress, setSavingInProgress] = useState(false);
    const domainRegex =/^(?:https?:\/\/)?(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9](?:\/.*)?$/i;
    const wrapperRef = useRef();

    const [selectedInsIds, setSelectedInsIds] = useState([]);


    useEffect(() => {
        setInstitutionData(JSON.parse(JSON.stringify(institutions)));
    }, [institutions]);

    useEffect(() => {
        setIsEdit(view === EVENT_BANNER_PAGE_VIEW_TYPES.EDIT);
    }, [view]);

    useEffect(() => {
        let copy = JSON.parse(JSON.stringify(selectedBannerEvent));
        setTempBannerEvent(copy);
    }, [selectedBannerEvent]);

    const isSaveBtnDisabled = () => {
        if (savingInProgress) {
            return true;
        }


        let val = acknowledgeText ? acknowledgeText.trim() : "";

        return val.toUpperCase() !== "I understand".toUpperCase();
    }

    const isNextBtnDisabled = () => {
        if (savingInProgress) {
            return true;
        }


        if (tempBannerEvent.location === EVENT_BANNER_LOCATION_TYPES.SELECTION.value
            && (!tempBannerEvent.institutions || !tempBannerEvent.institutions.length)) {
            return true;
        }

        if (!tempBannerEvent.roles || !tempBannerEvent.roles.length) {
            return true;
        }

        if (!tempBannerEvent.description) {
            return true;
        }

        if (!tempBannerEvent.link || ! domainRegex.test(tempBannerEvent.link)) {
            return true;
        }

        if (!tempBannerEvent.button) {
            return true;
        }

        if (!tempBannerEvent.startDate) {
            return true;
        }

        if (!tempBannerEvent.endDate) {
            return true;
        }

        if (isEdit && JSON.stringify(selectedBannerEvent) === JSON.stringify(tempBannerEvent)) {
            return true;
        }

        return false;

    }

    const onNext = () => {
        if (isEdit) {
            setSavingInProgress(true);
            saveEventBanner(tempBannerEvent, false).then(res => {
                if (res) {
                    setView(EVENT_BANNER_PAGE_VIEW_TYPES.LIST);
                }
            })

        } else {
            setView(EVENT_BANNER_PAGE_VIEW_TYPES.PREVIEW);
        }

    }

    const onCreate = () => {
        setSavingInProgress(true);
        saveEventBanner(tempBannerEvent, true).then(res => {
            if (res) {
                setView(EVENT_BANNER_PAGE_VIEW_TYPES.LIST);
            }
        });
    }

    useEffect(() => {
        if (isInstitutionsDialogOpened) {
            setSelectedInsIds(!!tempBannerEvent?.institutions ? tempBannerEvent.institutions : []);
        }
    }, [isInstitutionsDialogOpened]);

    const onSelectInstIds = () => {
        let copy = JSON.parse(JSON.stringify(tempBannerEvent));
        copy.institutions = JSON.parse(JSON.stringify(selectedInsIds));
        setTempBannerEvent(copy);
    }


    if (view === EVENT_BANNER_PAGE_VIEW_TYPES.PREVIEW) {
        return (
            <div className={`${classes.parent} ${classes.column}`}>
                <YuJaDialog
                    open={isSelectedInstDialogOpened}
                    setOpen={setIsSelectedInstDialogOpened}
                    title={t("institution.selectedInstitutions")}
                    closeText={"Cancel"}
                    centerAligned={false}
                    style={{maxHeight: 725}}
                >
                    <div className={classes.tableWrapper}>
                        <Table>
                            <thead>
                            <tr>
                                <TableSortHeaderNew
                                    data={institutionData}
                                    setData={setInstitutionData}
                                    sortedBy={selectedInstitutionSortedBy}
                                    setSortedBy={setSelectedInstitutionSortedBy}
                                    propertyName={"fullName"}
                                    label={t("institution.csmInstitutionTableNameHeader")}
                                    {...{style: {
                                            textAlign: 'left',
                                        }}}
                                >
                                    {t("institution.csmInstitutionTableNameHeader")}
                                </TableSortHeaderNew>
                            </tr>
                            </thead>
                            <tbody>
                            {institutionData
                                .filter((inst) => tempBannerEvent.institutions.includes(inst.institutionId))
                                .map((inst, index) =>
                                    <tr key={index}>
                                        <td style={{textAlign: "left"}}>
                                            {inst.fullName}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </YuJaDialog>

                <div
                    className={`${classes.card} ${classes.column}`}
                    style={{flex: 1, minHeight: 350, overflowY: "auto", gap: 15, paddingBottom: 0}}
                >
                    <div className={`${classes.card} ${classes.row} ${classes.titleCard}`}>
                        <div className={classes.titleText} style={{margin: 0}}>
                            {t("accessibility.eventsBannerText")}
                        </div>
                    </div>

                    <div className={classes.titleText} style={{alignSelf: "center", fontSize: 18}}>
                        {t("institution.bannerPreviewConfirmation")}
                    </div>

                    <div className={classes.column} style={{gap: 15, flex: 1}}>
                        <div className={classes.previewContainer}>
                            <div className={BannerClasses.EventBanner} style={{zIndex: "unset"}}>
                                <div ref={wrapperRef} className={BannerClasses.centralWrapper}>
                                    <div className={BannerClasses.bannerScrollContainer} style={{paddingLeft: 20}}>
                                        <BannerContent
                                            banner={tempBannerEvent}
                                            type={"current"}
                                            wrapperRef={wrapperRef}
                                            showMultipleBanners={false}
                                        />
                                    </div>
                                </div>
                                <div className={styles.closePresentation}>
                                    <Close/>
                                </div>
                            </div>

                        </div>
                        <Separator orientation={"horizontal"} className={classes.separator}/>

                        <div
                            className={classes.row}
                            style={{columnGap: 30, rowGap: 12, flexWrap: "wrap",}}
                        >
                            <div className={classes.column} style={{width: 350, flexShrink: 0}}>
                                <div className={SettingsClasses.settingLabel}>{t("institution.bannerPublishConfirmation")}</div>
                                <div className={SettingsClasses.settingDescription}>
                                {t("institution.bannerPublishAcknowledge")}
                                </div>
                            </div>

                            <YuJaTextField
                                inputStyles={{width: 350}}
                                size={"small"}
                                value={!!acknowledgeText ? acknowledgeText : ""}
                                placeholder={t("institution.bannerEnterIUnderstand")}
                                onChange={(val) => {
                                  setAcknowledgeText(val);
                                }}
                            />
                        </div>
                        {tempBannerEvent.institutions.length > 0 &&
                            <YuJaButton onClick={() => setIsSelectedInstDialogOpened(true)}>
                                {t("institution.selectedInstitutions")}
                            </YuJaButton>
                        }

                    </div>

                    <div className={classes.footer}>
                        <YuJaButton
                            size={"small"}
                            style={{width: 90}}
                            onClick={() => setView(EVENT_BANNER_PAGE_VIEW_TYPES.CREATE)}
                        >{t("common.back")}</YuJaButton>

                        <div style={{flex: 1}}/>

                        <YuJaButton
                            size={"small"}
                            type={"secondary"}
                            style={{width: 90}}
                            onClick={onBack}
                        >{t("common.cancel")}</YuJaButton>
                        <YuJaButton
                            onClick={onCreate}
                            isLoading={savingInProgress}
                            disabled={isSaveBtnDisabled()}
                            size={"small"}
                            style={{width: 90}}
                        >{t("common.create")}</YuJaButton>
                    </div>
                </div>
            </div>
        );
    }


    return (
        <div className={`${classes.parent} ${classes.column}`}>
            <YuJaDialog
                open={isInstitutionsDialogOpened}
                setOpen={setIsInstitutionsDialogOpened}
                title={t(EVENT_BANNER_LOCATION_TYPES.SELECTION.labelKey)}
                closeText={"Cancel"}
                onSubmit={() => onSelectInstIds()}
                isSubmitBtnDisabled={!selectedInsIds.length}
                submitText={t("common.select")}
                style={{maxHeight: 725, width: "min(420px, calc(100vw - 2rem))"}}
            >
                <div className={classes.tableWrapper}>
                    <Table>
                        <thead>
                        <tr>
                            <th style={{paddingLeft: 20, textAlign: "center", width: 80}}>
                                <YuJaCheckbox
                                    checked={!!selectedInsIds.length}
                                    indeterminate={
                                        !!selectedInsIds.length
                                        && selectedInsIds.length !== institutionData?.length
                                    }
                                    onChange={(checked) => {
                                        let copy = [];
                                        if (checked) {
                                            copy = institutionData.map(inst => inst.institutionId);
                                        }

                                        setSelectedInsIds(copy);
                                    }}
                                    />
                                </th>
                                <TableSortHeaderNew
                                    data={institutionData}
                                    setData={setInstitutionData}
                                    sortedBy={sortedBy}
                                    setSortedBy={setSortedBy}
                                    propertyName={"fullName"}
                                    label={t("institution.csmInstitutionTableNameHeader")}
                                    {...{style: {
                                        textAlign: 'left',
                                    }}}
                                >
                                    {t("institution.csmInstitutionTableNameHeader")}
                                </TableSortHeaderNew>
                            </tr>
                        </thead>
                        <tbody>
                            {institutionData.map((inst, index) =>
                                <tr key={index}>
                                    <td style={{paddingLeft: 20, textAlign: "center"}}>
                                        <YuJaCheckbox
                                            checked={selectedInsIds.includes(inst.institutionId)}
                                            onChange={(checked) => {
                                                let copy = JSON.parse(JSON.stringify(selectedInsIds));
                                                copy = copy.filter(id => id !== inst.institutionId);
                                                if (checked) {
                                                    copy.push(inst.institutionId);
                                                }

                                                setSelectedInsIds(copy);
                                            }}
                                        />
                                    </td>

                                    <td
                                        title={inst.fullName}
                                        style={{
                                            textAlign: "left",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        }}
                                    >
                                        {inst.fullName}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </YuJaDialog>
            <div
                className={`${classes.card} ${classes.column}`}
                style={{
                    flex: 1, minHeight: 350,
                    overflowY: "auto", gap: 15,
                    padding: "32px 32px 0 32px"
                }}
            >
                <div className={`${classes.card} ${classes.row} ${classes.titleCard}`}>
                    <div className={classes.titleText} style={{margin: 0}}>
                        {t("accessibility.eventsBannerText")}
                    </div>
                </div>
                <Button
                    className={classes.row}
                    style={{cursor: "pointer", width: "fit-content", border: "none", background: "none",}}
                    onClick={onBack}
                >
                    <BACK style={{marginRight: 3}}/>{t("common.back")}
                </Button>
                <div className={classes.column} style={{gap: 15, flex: 1}}>
                    <div className={SettingsClasses.settingDescription}>
                        {t("institution.bannerCreateDesc")}
                    </div>
                    <div
                        className={classes.row}
                        style={{
                            columnGap: 30,
                            rowGap: 12,
                            flexWrap: "wrap",
                            alignItems: tempBannerEvent.location === "SELECTION" ? "flex-start" : "center",
                        }}
                    >
                        <div className={classes.column} style={{width: 230, flexShrink: 0}}>
                            <div className={SettingsClasses.settingLabel}>{t("institution.bannerDisplayLocation")}</div>
                            <div className={SettingsClasses.settingDescription}>
                                {t("institution.bannerDisplayLocationDesc")}
                            </div>
                        </div>


                        <div className={classes.column} style={{gap: 10}}>
                            <YuJaRadioGroup
                                value={tempBannerEvent.location}
                                data={Object.values(EVENT_BANNER_LOCATION_TYPES).map(type => ({...type, label: t(type.labelKey)}))}
                                onchange={val => {
                                    let copy = JSON.parse(JSON.stringify(tempBannerEvent));
                                    copy.location = val;
                                    setTempBannerEvent(copy);
                                }}
                            />

                            {tempBannerEvent.location === EVENT_BANNER_LOCATION_TYPES.SELECTION.value &&
                                <>
                                    <div className={classes.row}>
                                        <YuJaTooltip
                                            disabled={!!institutionData && !!institutionData.length}
                                            text={t("institution.bannerNoPublishPermission")}
                                            placement={"bottom"}
                                        >
                                            <YuJaButton
                                                size={"small"}
                                                disabled={!institutionData || !institutionData.length}
                                                onClick={() => setIsInstitutionsDialogOpened(true)}
                                            >
                                                {t(EVENT_BANNER_LOCATION_TYPES.SELECTION.labelKey)}
                                            </YuJaButton>
                                        </YuJaTooltip>

                                        <div style={{marginLeft: 10}}>
                                                ({!!tempBannerEvent.institutions ? tempBannerEvent.institutions.length : 0}
                                            {" selected"})
                                        </div>
                                    </div>
                                    {(!tempBannerEvent.institutions || tempBannerEvent.institutions.length === 0) &&
                                        <div>
                                            <ERROR style={{marginRight: 5}}/> {t("institution.bannerSelectAtLeastOne")}
                                        </div>
                                    }
                                </>

                            }
                        </div>
                    </div>

                    <div
                        className={classes.row}
                        style={{columnGap: 30, rowGap: 12, flexWrap: "wrap",}}
                    >
                        <div className={classes.column} style={{width: 230, flexShrink: 0}}>
                            <div className={SettingsClasses.settingLabel}>{t("auth.roleLabel")}</div>
                            <div className={SettingsClasses.settingDescription}>
                                {t("institution.bannerRolesDesc")}
                            </div>
                        </div>

                        <YuJaSelect
                            multiple={true}
                            size={"small"}
                            isValid={roleValid}
                            errorMsg={roleErrorMsg}
                            options={[
                                {value: ALL_ROLES, label: t("user.allRolesText")},
                                {value: CREATION_ROLES.IT_MANAGER.value, label: t(CREATION_ROLES.IT_MANAGER.labelKey)},
                                {value: CREATION_ROLES.CREATOR.value, label: t(CREATION_ROLES.CREATOR.labelKey)},
                                {value: CREATION_ROLES.VIEWER.value, label: t(CREATION_ROLES.VIEWER.labelKey)},
                            ]}
                            onChange={val => {
                                let copy = JSON.parse(JSON.stringify(tempBannerEvent));
                                let oldRoles = !!copy.roles ? copy.roles : [];
                                if (!oldRoles.includes(ALL_ROLES) && val.includes(ALL_ROLES)) {
                                    copy.roles = [t("user.allRolesText")];
                                } else if (oldRoles.includes(ALL_ROLES) && val.includes(ALL_ROLES) && val.length > 1) {
                                    copy.roles = val.filter(i => i !== ALL_ROLES);
                                } else {
                                    copy.roles = val;
                                }
                                setTempBannerEvent(copy);

                                if (!copy.roles.length) {
                                    setRoleValid(false);
                                    setRoleErrorMsg("This field is required");
                                } else {
                                    setRoleValid(true);
                                    setRoleErrorMsg("");
                                }
                            }}
                            value={tempBannerEvent.roles}
                            placeholder={t("institution.bannerSelectRoles")}
                            style={{width: 350}}
                        />
                    </div>

                    <div
                        className={classes.row}
                        style={{columnGap: 30, rowGap: 12, flexWrap: "wrap",}}
                    >
                        <div className={classes.column} style={{width: 230, flexShrink: 0}}>
                            <div className={SettingsClasses.settingLabel}>{t("institution.bannerDescription")}</div>
                            <div className={SettingsClasses.settingDescription}>
                                {t("institution.bannerDescriptionDesc")}
                            </div>
                        </div>

                        <YuJaTextArea
                            isValid={descriptionValid}
                            errorMsg={descriptionErrorMsg}
                            inputStyle={{width: 350, height: 80}}
                            value={!!tempBannerEvent.description ? tempBannerEvent.description : ""}
                            placeholder={t("institution.bannerDescriptionPlaceholder")}
                            onChange={(val) => {
                                let copy = JSON.parse(JSON.stringify(tempBannerEvent));
                                copy.description = val;
                                setTempBannerEvent(copy);
                                if (!val) {
                                    setDescriptionValid(false);
                                    setDescriptionErrorMsg("This field is required");
                                } else {
                                    setDescriptionValid(true);
                                    setDescriptionErrorMsg("");
                                }
                            }}
                            onBlur={(e) => {
                                let trimmedVal = e.target.value.trim();
                                let copy = JSON.parse(JSON.stringify(tempBannerEvent));
                                copy.description = trimmedVal;
                                setTempBannerEvent(copy);
                                if (!trimmedVal) {
                                    setDescriptionValid(false);
                                    setDescriptionErrorMsg("This field is required");
                                }

                            }}
                        />
                    </div>

                    <div
                        className={classes.row}
                        style={{columnGap: 30, rowGap: 12, flexWrap: "wrap",}}
                    >
                        <div className={classes.column} style={{width: 230, flexShrink: 0}}>
                            <div className={SettingsClasses.settingLabel}>{t("institution.bannerRegistrationLink")}</div>
                            <div className={SettingsClasses.settingDescription}>
                                {t("institution.bannerRegistrationLinkDesc")}
                            </div>
                        </div>

                        <YuJaTextField
                            inputStyles={{width: 350}}
                            isValid={domainValid}
                            errorMsg={domainErrorMsg}
                            size={"medium"}
                            value={!!tempBannerEvent.link ? tempBannerEvent.link : ""}
                            placeholder={t("institution.bannerRegistrationLinkPlaceholder")}
                            description={
                                domainValid && !!tempBannerEvent.link &&
                                <Fragment><CHECK style={{flexShrink: 0}}/> <span>{t("institution.bannerValidDomain")}</span></Fragment>
                            }
                            onChange={(val) => {
                                let copy = JSON.parse(JSON.stringify(tempBannerEvent));
                                copy.link = val;
                                setTempBannerEvent(copy);

                                if (!val) {
                                    setDomainValid(false);
                                    setDomainErrorMsg("This field is required");
                                } else {
                                    let matched = domainRegex.test(val);
                                    setDomainValid(matched);
                                    if (!matched) {
                                        setDomainErrorMsg("Invalid domain");
                                    } else {
                                        setDomainErrorMsg("");
                                    }
                                }

                            }}
                            onBlur={(e) => {
                                let trimmedVal = e.target.value.trim();
                                let copy = JSON.parse(JSON.stringify(tempBannerEvent));
                                copy.link = trimmedVal;
                                setTempBannerEvent(copy);
                                if (!trimmedVal) {
                                    setDomainValid(false);
                                    setDomainErrorMsg("This field is required");
                                }

                            }}
                        />
                    </div>

                    <div
                        className={classes.row}
                        style={{columnGap: 30, rowGap: 12, flexWrap: "wrap",}}
                    >
                        <div className={classes.column} style={{width: 230, flexShrink: 0}}>
                            <div className={SettingsClasses.settingLabel}>{t("institution.bannerRegistrationButton")}</div>
                            <div className={SettingsClasses.settingDescription}>
                                {t("institution.bannerRegistrationButtonDesc")}
                            </div>
                        </div>

                        <YuJaTextArea
                            isValid={buttonValid}
                            errorMsg={buttonErrorMsg}
                            inputStyle={{width: 350, height: 80}}
                            maxLength={25}
                            value={!!tempBannerEvent.button ? tempBannerEvent.button : ""}
                            placeholder={t("institution.bannerRegistrationButtonPlaceholder")}
                            onChange={(val) => {
                                let copy = JSON.parse(JSON.stringify(tempBannerEvent));
                                copy.button = val;
                                setTempBannerEvent(copy);
                                if (!val) {
                                    setButtonValid(false);
                                    setButtonErrorMsg("This field is required");
                                } else {
                                    setButtonValid(true);
                                    setButtonErrorMsg("");
                                }
                            }}
                            onBlur={(e) => {
                                let trimmedVal = e.target.value.trim();
                                let copy = JSON.parse(JSON.stringify(tempBannerEvent));
                                copy.button = trimmedVal;
                                setTempBannerEvent(copy);
                                if (!trimmedVal) {
                                    setButtonValid(false);
                                    setButtonErrorMsg("This field is required");
                                }

                            }}
                        />
                    </div>


                    <div
                        className={classes.row}
                        style={{columnGap: 30, rowGap: 12, flexWrap: "wrap",}}
                    >
                        <div className={classes.column} style={{width: 230, flexShrink: 0}}>
                            <div className={SettingsClasses.settingLabel}>{t("institution.bannerSchedule")}</div>
                            <div className={SettingsClasses.settingDescription}>
                                {t("institution.bannerScheduleDesc")}
                            </div>
                        </div>

                        <div className={classes.row} style={{width: 350, gap: 5}}>
                            <YuJaDatePicker
                                textFieldStyle={{flex: 1, minWidth: 0}}
                                date={tempBannerEvent.startDate}
                                maxDate={tempBannerEvent.endDate}
                                onChange={value => {
                                    let copy = JSON.parse(JSON.stringify(tempBannerEvent));
                                    if (!!value) {
                                        copy.startDate = value;
                                    } else {
                                        copy.startDate = "";
                                    }
                                    setTempBannerEvent(copy);
                                }}
                            />

                            <ARROW_RIGHT style={{flexShrink: 0}}/>

                            <YuJaDatePicker
                                textFieldStyle={{flex: 1, minWidth: 0}}
                                date={tempBannerEvent.endDate}
                                minDate={tempBannerEvent.startDate}
                                onChange={value => {
                                    let copy = JSON.parse(JSON.stringify(tempBannerEvent));
                                    if (!!value) {
                                        copy.endDate = value;
                                    } else {
                                        copy.endDate = "";
                                    }
                                    setTempBannerEvent(copy);
                                }}
                            />

                        </div>
                    </div>
                </div>
                <div className={classes.footer}>
                    <YuJaButton
                        style={{minWidth: 90, height: 35}}
                        onClick={onBack}
                    >{t("common.back")}</YuJaButton>
                    <div style={{flex: 1}}/>

                    <YuJaButton
                        onClick={onNext}
                        disabled={isNextBtnDisabled()}
                        isLoading={savingInProgress}
                        style={{minWidth: 90, height: 35}}
                    >{isEdit ? t("accessibility.confirmChangesText") : t("common.next")}</YuJaButton>
                </div>
            </div>
        </div>
    );
}